import PropTypes from 'prop-types'
import React, {useEffect, useLayoutEffect, useState} from 'react';
import styles from './SegmentedSlider.module.scss'
/**
 * Display a segmented tracker with a segment for each value in the values prop
 * @param defaultValue
 * @param values the values that represent each segment
 * @param onChange
 * @returns {JSX.Element}
 * @constructor
 */
function SegmentedSlider({caption = '',
                             variant,
                             defaultValue = 0,
                             values = [],
                             disabled = false,
                             onChange = () =>{} }) {
    const defaultIndex = values.indexOf(defaultValue)
    const [currentSelected, setCurrentSelected]  = React.useState( () => {
            return defaultValue
    })
    const sliderRef = React.createRef()
    const [segments, setSegments] = useState(() => {
        return values.map(v => {
            return {
                value: v,
            }
        })
    })
    useEffect( () => {
        if (currentSelected > -1 && currentSelected < values.length ) {
            onChange( values[currentSelected] )
        }
    }, [currentSelected])
    useLayoutEffect( () => {
        const segmentsDiv = sliderRef.current
        if (segmentsDiv) {
            let sliderRect = segmentsDiv.getBoundingClientRect();
            const s = segmentsDiv.querySelectorAll("."+styles.Segment)
            const newSegments = []
            for (let i = 0; i < s.length; i++) {
                let rect = s[i].getBoundingClientRect();
                const posX =  rect.x - sliderRect.x
                newSegments.push({
                    value: segments[i].value,
                    x: posX
                })

            }
            setSegments(newSegments)
        }
    }, [values])
    const handleSliderClick = (e) => {
        if (disabled) return
        if (!segments[currentSelected]) {
            console.warn("not selected: ", currentSelected)
            return;
        }
        const numSegments = segments.length
        const pxPerSegment =  segments.slice(-1)[0].x / numSegments
        let rect = e.currentTarget.getBoundingClientRect();
        let x = e.clientX - rect.left; //x position within the element.
        const distance = Math.round(Math.abs(x - segments[currentSelected].x) / pxPerSegment)
        if (x > segments[currentSelected].x && currentSelected < segments.length-1) {
            setCurrentSelected(currentSelected + distance < segments.length ? currentSelected + distance :segments.length-1)

            return
        }
        if (x < segments[currentSelected].x && currentSelected > 0) {
            let newSelected = currentSelected - distance >= 0 ? currentSelected - distance :0
            newSelected = newSelected > segments.length-1 ? segments.length-1 : newSelected
            newSelected = newSelected < 0 ? 0 : newSelected
            setCurrentSelected(newSelected)
            return
        }
    }
    return <div className={`${styles.Container} ${variant === 'single' ? styles.single : ''}`}>
        <div className={`${styles.Header} ${variant === 'slim' ? styles.slim : ''}  ` } >{caption}</div>
        <div ref={sliderRef} className={`${styles.SegmentedSlider} ${variant === 'slim' && styles.slim}`} onClick={handleSliderClick} >
        <div className={`${styles.Bar} ${variant === 'slim' && styles.slim}`}  />
        <div  className={styles.Segments}>
        {segments && segments.map( (v,i) => {
            const isCurrent = i === currentSelected
            return <div key={v.value} className={`${styles.Segment}`} id={`${styles.Segment}_${i}`}>
                <div className={ `${styles.Mark} ${variant === 'slim' && styles.slim} ${isCurrent === true && styles.Thumb}`}

                >&nbsp;</div>
            </div>
        })}
        </div>
    </div>
    </div>
}
export default SegmentedSlider;

SegmentedSlider.propTypes = {
  defaultValue: PropTypes.any,
  onChange: PropTypes.any,
  values: PropTypes.array
}

SegmentedSlider.defaultProps = {
  onChange: () =>{},
  values: []
}
